import * as React from 'react';
import { useCallback, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import CommonNotesChatPage from '../common_notes_chat_page/CommonNotesChatPage';
import CommonNoteInputForm from '../common_note_input_form/CommonNoteInputForm';
import { withUserType } from '../withUserType';
import { WEB_SOCKET_ENTITY_TYPES } from '../../utils/WebSocketUtils';

// Project Notes reuses the exact work-order / walkthrough notes UI
// (CommonNotesChatPage + CommonNoteInputForm). There is no project-notes backend
// yet, so notes are held in local state for the demo — swap `appendNote` /
// `fetchNotes` for real thunks (writing into state.messages) once an endpoint
// exists, exactly like WorkOrdersDetailNotesPage. Behind projects-v2.
const WS_CONFIG = {
	entityIdName: 'projectId',
	entityType: WEB_SOCKET_ENTITY_TYPES.WORK_ORDER_NOTES,
	newNoteEntityType: WEB_SOCKET_ENTITY_TYPES.WORK_ORDER,
};

const ProjectNotesTab = ({ currentUser, userType, match }: any) => {
	const projectId = match.params.id;
	const entityId = `project-${projectId}`;

	const [notes, setNotes] = useState<any[]>([]);

	// Feed local notes through the same shape CommonNotesChatPage reads from
	// state.messages: { [entityId]: { messages: [...] } }.
	const messages = useMemo(() => ({ [entityId]: { messages: notes } }), [entityId, notes]);

	const fetchNotes = useCallback(() => Promise.resolve(notes), [notes]);

	const appendNote = useCallback((note: any) => {
		setNotes((prev) => [...prev, note]);
		return Promise.resolve(note);
	}, []);

	const renderInputForm = useCallback(
		({ handleTyping, onSendNote, typingDetails, newNoteCount, onRefresh }) => (
			<CommonNoteInputForm
				appendNote={appendNote}
				currentUser={currentUser}
				onTyping={handleTyping}
				onSendNote={onSendNote}
				typingDetails={typingDetails}
				newNoteCount={newNoteCount}
				onRefresh={onRefresh}
				fetchMentionUsers={() => Promise.resolve([])}
			/>
		),
		[appendNote, currentUser]
	);

	return (
		<CommonNotesChatPage
			entityId={entityId}
			fetchNotes={fetchNotes}
			userType={userType}
			heightSelector="detailPage"
			wsConfig={WS_CONFIG}
			currentUser={currentUser}
			messages={messages}
			renderInputForm={renderInputForm}
		/>
	);
};

export default withUserType(
	withRouter(
		connect((state: any) => ({
			currentUser: state.session.currentUser,
		}))(ProjectNotesTab)
	)
);
